// features/canvas/constants/character-limits.ts

export const CHARACTER_LIMITS = {
  // Large fields (descriptions, budget custom fields)
  LARGE_FIELD: 2000,

  // Initiative titles and filter titles
  TITLE: 200,

  // Budget field titles
  BUDGET_TITLE: 200,

  // Display limit for canvas nodes (with ellipsis)
  TITLE_DISPLAY: 32,

  // Display limit for custom field titles (with ellipsis)
  CUSTOM_FIELD_TITLE_DISPLAY: 45,

  // Display limit for dialog titles (with ellipsis)
  DIALOG_TITLE_DISPLAY: 85,

  // TimePeriod and Section titles
  TIMEPERIOD_SECTION_TITLE: 45,

  // Custom small field content
  CUSTOM_SMALL_CONTENT: 40,

  // Legacy limits (keeping for backward compatibility)
  CUSTOM_FIELD_MAX_MULTI_LINE_LENGTH: 2000,
  CUSTOM_FIELD_MAX_SINGLE_LINE_LENGTH: 40,
} as const;
